export function toUserType(_ref) {
  var isBot = _ref.isBot,
    appType = _ref.appType;
  // Note, the order of these checks is important
  if ((appType === null || appType === void 0 ? void 0 : appType.toLocaleLowerCase()) === 'agent') {
    return 'agent';
  }
  if (isBot) {
    return 'bot';
  }
  return 'user';
}